import { ModalPelican } from './component';

export * from './component';
export default ModalPelican;
